<template>
  <div id="app-index">
    <project-head></project-head>
    <nav-bar></nav-bar>
    <project-nav></project-nav>
    <project-foot></project-foot>
  </div>
</template>
<script>
import animate from 'animate.css'
import projectHead from "../Public/head";
import navBar from "../Public/nav";
import projectNav from "./project_nav";
import projectFoot from "../Public/foot";    

export default {
  components:{
    projectHead,
    navBar,
    projectFoot,
    projectNav
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Project/project_index.vue